<template>
    <a-card :bordered="false" class="bl-card" :style="selectedOfferKeys.length && { marginBottom: '60px' }">
        <div class="bl-filterbar">
            <a-input
                class="bl-search-input"
                placeholder="Buscar por loja ou fornecedor"
                v-model="search"
                allow-clear
            />
        </div>
        <a-table
            size="small"
            :columns="columns"
            :data-source="rows"
            :loading="products_loading"
            row-key="store_id"
            :expandedRowKeys="expanded"
            :expand-icon-column-index="1"
            :locale="{ emptyText: 'Nenhum pré-pedido pendente.' }"
            @expand="onExpandChange"
            :pagination="false"
        >
            <template slot="selecionarHeader">
                <a-checkbox
                    :checked="isAllFullySelected()"
                    :indeterminate="isAllPartiallySelected()"
                    @change="toggleAllSelection($event.target.checked)"
                />
            </template>
            <template slot="selecionar" slot-scope="text, record">
                <a-checkbox
                    :checked="isLojaFullySelected(record)"
                    :indeterminate="isLojaPartiallySelected(record)"
                    @change="toggleLojaSelection(record, $event.target.checked)"
                />
            </template>
            <template slot="loja" slot-scope="text, record">
                <div class="bl-strong">{{ record.store_name }}</div>
            </template>
            <template slot="fornecedores" slot-scope="text, record">{{ record.pendingProviders.length }}</template>
            <template slot="valor" slot-scope="text, record">{{ storeTotal(record) | currency }}</template>
            <template slot="acoes" slot-scope="text, record">
                <ActionMenu :actions="lojaActions(record)" />
            </template>

            <template slot="expandedRowRender" slot-scope="record">
                <div class="expanded-table-wrapper">
                <a-table
                    size="small"
                    :columns="innerColumns"
                    :data-source="record.pendingProviders"
                    :pagination="false"
                    row-key="key"
                    :expand-icon-column-index="1"
                >
                    <template slot="selecionar" slot-scope="text, provider">
                        <a-checkbox
                            :checked="isProviderFullySelected(provider)"
                            :indeterminate="isProviderPartiallySelected(provider)"
                            @change="toggleProviderSelection(provider, $event.target.checked)"
                        />
                    </template>
                    <template slot="fornecedor" slot-scope="text, provider">
                        <div class="bl-sup">
                            <span class="bl-n">
                                {{ provider.provider_name }}<template v-if="provider.provider_cnpj"> · {{ provider.provider_cnpj }}</template>
                            </span>
                            <span class="bl-v" v-if="provider.seller_name">
                                {{ provider.seller_name }}<template v-if="provider.seller_phone"> · {{ provider.seller_phone }}</template>
                            </span>
                        </div>
                    </template>
                    <template slot="cond" slot-scope="text, provider">{{ provider.payment_condition || "-" }}</template>
                    <template slot="entrega" slot-scope="text, provider">{{ deliveryDate(provider) }}</template>
                    <template slot="tipoEntrega" slot-scope="text, provider">{{ provider.delivery_type || "—" }}</template>
                    <template slot="faturamentoMinimo" slot-scope="text, provider">
                        <span v-if="provider.minimum_billing">{{ provider.minimum_billing | currency }}</span>
                        <span v-else>-</span>
                    </template>
                    <template slot="valor" slot-scope="text, provider">
                        <span :class="{ 'bl-below-min': isBelowMin(provider) }">{{ fornecedorTotal(provider) | currency }}</span>
                    </template>
                    <template slot="acoes" slot-scope="text, provider">
                        <ActionMenu :actions="providerActions(record, provider)" />
                    </template>

                    <template slot="expandedRowRender" slot-scope="provider">
                        <div class="expanded-table-wrapper">
                            <a-table
                                size="small"
                                :columns="productColumns"
                                :data-source="provider.products"
                                :pagination="false"
                                row-key="key"
                                :expand-icon="crossExpandIcon"
                                :locale="{ emptyText: 'Nenhum produto pendente.' }"
                            >
                                <template slot="selecionarProduto" slot-scope="text, product">
                                    <a-checkbox
                                        :checked="isProductFullySelected(product)"
                                        :indeterminate="isProductPartiallySelected(product)"
                                        @change="toggleProductSelection(product, $event.target.checked)"
                                    />
                                </template>

                                <template slot="expandedRowRender" slot-scope="product">
                                    <div class="expanded-table-wrapper" v-if="product.isCrossGroup">
                                        <a-table
                                            size="small"
                                            :columns="crossStoreColumns"
                                            :data-source="product.stores"
                                            :pagination="false"
                                            row-key="key"
                                            :row-selection="crossStoreRowSelection(product)"
                                            :locale="{ emptyText: 'Nenhuma loja pendente.' }"
                                        >
                                            <template slot="crossLoja" slot-scope="text, item">{{ item.store_name }}</template>

                                            <template slot="requisicao" slot-scope="text, item">
                                                {{ item.request_quantity != null ? item.request_quantity : "—" }}
                                            </template>

                                            <template slot="pedido" slot-scope="text, item">
                                                <span class="matrix-qty-wrap" :class="{ saved: !!savedCells[item.key] }">
                                                    <a-input
                                                        :min="0"
                                                        data-field="loja-qty"
                                                        class="matrix-qty-input"
                                                        v-model="item.requested_quantity"
                                                        @input="handleQuantityInput($event, item)"
                                                        @focus="handleFocus(item)"
                                                        @blur="saveQuantity(item)"
                                                        @keydown.native="handleQtyKeydown($event)"
                                                    />
                                                </span>
                                            </template>

                                            <template slot="total" slot-scope="text, item">
                                                {{ item.total | currency }}
                                            </template>
                                        </a-table>
                                    </div>
                                </template>

                                <template slot="nome" slot-scope="text, product">
                                    <div class="vpm-pname">{{ product.name }}</div>
                                    <div class="vpm-pean" v-if="product.ean || product.internal_code">
                                        <template v-if="product.ean">EAN {{ product.ean }}</template>
                                        <template v-if="product.ean && product.internal_code"> · </template>
                                        <template v-if="product.internal_code">Cód. {{ product.internal_code }}</template>
                                    </div>
                                </template>

                                <template slot="ressuprimento" slot-scope="text, product">
                                    <span class="repl-tag" v-if="replenishment(product)">
                                        {{ replenishment(product) }}
                                    </span>
                                    <span v-else>--</span>
                                </template>

                                <template slot="requisicao" slot-scope="text, product">
                                    {{ product.request_quantity != null ? product.request_quantity : "—" }}
                                </template>

                                <template slot="pedido" slot-scope="text, product">
                                    <span v-if="product.isCrossGroup" class="matrix-cross-total">
                                        {{ crossGroupOrdered(product) }}
                                    </span>
                                    <template v-else>
                                        <span class="matrix-qty-wrap" :class="{ saved: !!savedCells[product.key] }">
                                            <a-input
                                                :min="0"
                                                data-field="loja-qty"
                                                class="matrix-qty-input"
                                                v-model="product.requested_quantity"
                                                @input="handleQuantityInput($event, product)"
                                                @focus="handleFocus(product)"
                                                @blur="saveQuantity(product)"
                                                @keydown.native="handleQtyKeydown($event)"
                                            />
                                        </span>
                                    </template>
                                </template>

                                <template slot="digitacao" slot-scope="text, product">
                                    {{ product.offer_price | currency }}
                                </template>

                                <template slot="ultimaCompra" slot-scope="text, product">
                                    <span v-if="product.last_purchase != null">{{ product.last_purchase | currency }}</span>
                                    <span v-else>—</span>
                                </template>

                                <template slot="diferenca" slot-scope="text, product">
                                    <span v-if="product.last_purchase != null" :class="deltaClass(product)">
                                        {{ (product.offer_price - product.last_purchase) | currency }}
                                    </span>
                                    <span v-else>—</span>
                                </template>

                                <template slot="variacao" slot-scope="text, product">
                                    <span v-if="product.last_purchase != null" :class="deltaClass(product)">
                                        {{ variation(product).toFixed(1) }}%
                                    </span>
                                    <span v-else>—</span>
                                </template>

                                <template slot="total" slot-scope="text, product">
                                    {{ product.total | currency }}
                                </template>

                                <template slot="acoes" slot-scope="text, product">
                                    <ActionMenu :actions="productActions(product, provider)" />
                                </template>
                            </a-table>
                        </div>
                    </template>
                </a-table>
                </div>
            </template>
        </a-table>

        <NegotiationModal
            v-if="negotiationModal.open"
            :product="negotiationModal.product"
            :typing="negotiationModal.winner"
            :quotation_id="$route.params.id"
            @close="closeNegotiation"
        />

        <ProductWrapModal
            v-if="wrapModal.open"
            :product="wrapModal.product"
            :salesman="wrapModal.winner"
            @close="closeWrap"
        />

        <ProductOrdersModal
            v-if="historyModal.open"
            :product_id="historyModal.productId"
            :product_name="historyModal.productName"
            @close="historyModal.open = false"
        />

        <TypedProductsModal
            v-if="typedProductsModal.open"
            :quotation-id="$route.params.id"
            :provider-id="typedProductsModal.providerId"
            :provider-name="typedProductsModal.providerName"
            :seller-id="typedProductsModal.sellerId"
            :seller-name="typedProductsModal.sellerName"
            @close="closeTypedProducts"
            @reload="$emit('reload')"
        />

        <SellerPreOrderModal
            v-if="sellerPreOrderModal.open"
            :provider="sellerPreOrderModal.provider"
            :stores="stores"
            :quotation-id="$route.params.id"
            :generating="generating"
            @close="closeSellerPreOrder"
            @reload="$emit('reload')"
            @generate-orders="(keys) => $emit('generate-orders', keys)"
        />

        <ChangeWinnerModal
            v-if="changeWinnerModal.open"
            :product="changeWinnerModal.product"
            :pre-orders="products"
            :quotation-id="$route.params.id"
            @close="closeChangeWinner"
            @saved="onWinnerChanged"
        />

        <AddProductPickerModal
            v-if="addProductModal.open"
            :quotation-id="$route.params.id"
            :provider-name="addProductModal.provider.provider_name"
            :seller-name="addProductModal.provider.seller_name"
            :exclude-ids="leafProducts(addProductModal.provider.products).flatMap((p) => [p.id, p.main_product_id]).filter(Boolean)"
            @close="closeAddProduct"
            @select="openDistributionForNewProduct"
        />

        <StoreQuantityModal
            v-if="distributionModal.open"
            :winner="distributionModal.winner"
            :product="distributionModal.product"
            :quotation-id="$route.params.id"
            :mark-winner-on-save="distributionModal.markWinnerOnSave"
            @close="closeDistribution"
            @saved="onDistributionSaved"
            @price-updated="$emit('reload')"
        />

        <SelectionFooter
            :count="selectedOffers.length"
            item-label="ofertas selecionadas"
        >
            <template slot="summary">
                <strong>{{ selectedTotal | currency }}</strong>
            </template>

            <template slot="actions">
                <a-button size="large" @click="setSelection([])">Limpar seleção</a-button>
                <a-button size="large" @click="bulkExport">Exportar</a-button>
                <a-button size="large" @click="bulkZeroQuantity">Zerar quantidade</a-button>
                <a-button size="large" :loading="refreshingErp" :disabled="refreshingErp || generating" @click="$emit('refresh-erp', selectedOfferKeys)">Atualizar estoque/custo</a-button>
                <a-button size="large" type="primary" :disabled="generating" @click="bulkGenerateOrder">Gerar pedido</a-button>
            </template>
        </SelectionFooter>
    </a-card>
</template>

<script>
import QuotationService from "@/services/QuotationService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import currencyPrecision from "@/mixins/currencyPrecision";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { replenishmentStrategyMixin } from "@/mixins/replenishment-strategy.mixin";
import NegotiationModal from "@/modals/negotiate-offer/negotiate-offer.modal.vue";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal.vue";
import ProductOrdersModal from "@/modals/products/orders";
import ChangeWinnerModal from "@/modals/change-winner/change-winner.modal.vue";
import TypedProductsModal from "./_typed-products.modal.vue";
import SellerPreOrderModal from "./_seller-pre-order.modal.vue";
import StoreQuantityModal from "../comparativo/_store-quantity.modal.vue";
import AddProductPickerModal from "./_add-product-picker.modal.vue";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import SelectionFooter from "@/components/cliente/monitors/SelectionFooter.vue";
import { replenishmentLabel } from "@/helpers/replenishment";
import { buildSellerProviderMatrix } from "@/helpers/seller-provider-matrix";

const CROSS_STRATEGY = "CROSS";

const PRICE_LOCKED_TOOLTIP = "Pedido já gerado com este fornecedor — preço travado";

export default {
    name: "ByLojaTableV2",
    mixins: [currencyPrecision, loaderMixin, replenishmentStrategyMixin],
    components: { NegotiationModal, ProductWrapModal, ProductOrdersModal, ChangeWinnerModal, TypedProductsModal, SellerPreOrderModal, StoreQuantityModal, AddProductPickerModal, ActionMenu, SelectionFooter },
    props: {
        // Fetched once by the parent (_pre-orders.tab.vue) and shared with
        // Matriz/Por Produto/Analítico — same pre_orders_report() call for
        // all four, see [[winners-v2-backlog-triage]].
        products: { type: Array, default: () => [] },
        products_loading: { type: Boolean, default: false },
        orderedOffers: { type: Object, default: () => ({}) },
        // Another generate-orders call (from this view or a sibling one) is
        // still in flight — blocks new ones so an early reload can't run
        // while a later request is still writing [[pre-orders-generate-race]].
        generating: { type: Boolean, default: false },
        refreshingErp: { type: Boolean, default: false },
        pendencyOnly: { type: Boolean, default: false },
        // Shared with Por Produto / Analítico via `.sync` on the parent
        // (_pre-orders.tab.vue) — same row-key shape in all three:
        // `${produto}-${loja}-${fornecedor}-${vendedor}`.
        selectedOfferKeys: { type: Array, default: () => [] },
        // Same reasoning as selectedOfferKeys: owned by the parent and
        // shared across the 4 views so a "saved" marker survives switching
        // tabs, keyed the same way.
        savedCells: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            stores: [],
            groupedStores: [],
            svc: new QuotationService(),
            expanded: [],
            sending: {},
            negotiationModal: {
                open: false,
                winner: null,
                product: null,
            },
            wrapModal: {
                open: false,
                winner: null,
                product: null,
            },
            historyModal: {
                open: false,
                productId: null,
                productName: "",
            },
            typedProductsModal: {
                open: false,
                providerId: null,
                providerName: "",
                sellerId: null,
                sellerName: "",
            },
            sellerPreOrderModal: {
                open: false,
                provider: null,
            },
            changeWinnerModal: {
                open: false,
                product: null,
            },
            addProductModal: {
                open: false,
                provider: null,
            },
            distributionModal: {
                open: false,
                winner: null,
                product: null,
                markWinnerOnSave: false,
            },
            search: "",
        };
    },
    computed: {
        cdStore() {
            return this.stores.find((s) => s.is_cd) || null;
        },
        crossStoreColumns() {
            return [
                { title: "Loja", key: "loja", scopedSlots: { customRender: "crossLoja" } },
                { title: "Requisição", key: "requisicao", width: 90, align: "center", scopedSlots: { customRender: "requisicao" } },
                { title: "Pedido", key: "pedido", width: 110, align: "center", scopedSlots: { customRender: "pedido" } },
                { title: "Estoque", key: "inventory", width: 90, align: "center", customRender: (t, p) => (p.inventory != null ? this.$options.filters.stock(p.inventory) : "—") },
                { title: "Total", key: "total", width: 110, align: "right", scopedSlots: { customRender: "total" } },
            ];
        },
        productColumns() {
            return [
                { title: "", key: "selecionar", width: 40, align: "center", scopedSlots: { customRender: "selecionarProduto" } },
                { title: "Produto", key: "nome", width: 220, scopedSlots: { customRender: "nome" } },
                { title: "Reabastecimento", key: "ressuprimento", width: 130, align: "center", scopedSlots: { customRender: "ressuprimento" } },
                { title: "Qtd. Emb.", key: "packing", width: 90, align: "center", customRender: (t, p) => p.packing || "—" },
                { title: "Requisição", key: "requisicao", width: 90, align: "center", scopedSlots: { customRender: "requisicao" } },
                { title: "Pedido", key: "pedido", width: 110, align: "center", scopedSlots: { customRender: "pedido" } },
                { title: "Und. compra", key: "purchase_unity", width: 100, align: "center", customRender: (t, p) => p.purchase_unity || "—" },
                { title: "Estoque", key: "inventory", width: 90, align: "center", customRender: (t, p) => (p.inventory != null ? this.$options.filters.stock(p.inventory) : "—") },
                { title: "Digitação", key: "digitacao", width: 100, align: "right", scopedSlots: { customRender: "digitacao" } },
                { title: "Últ. Compra", key: "ultimaCompra", width: 100, align: "right", scopedSlots: { customRender: "ultimaCompra" } },
                { title: "Diferença", key: "diferenca", width: 100, align: "right", scopedSlots: { customRender: "diferenca" } },
                { title: "Variação", key: "variacao", width: 90, align: "right", scopedSlots: { customRender: "variacao" } },
                { title: "Total", key: "total", width: 110, align: "right", scopedSlots: { customRender: "total" } },
                { title: "Ações", key: "acoes", width: 60, scopedSlots: { customRender: "acoes" } },
            ];
        },
        columns() {
            return [
                { title: "", key: "selecionar", width: 40, align: "center", slots: { title: "selecionarHeader" }, scopedSlots: { customRender: "selecionar" } },
                { title: "Loja", key: "loja", scopedSlots: { customRender: "loja" } },
                { title: "Fornecedores pendentes", key: "fornecedores", align: "right", scopedSlots: { customRender: "fornecedores" } },
                { title: "Valor total", key: "valor", align: "right", scopedSlots: { customRender: "valor" } },
                { title: "Ações", key: "acoes", scopedSlots: { customRender: "acoes" } },
            ];
        },
        innerColumns() {
            return [
                { title: "", key: "selecionar", width: 40, align: "center", scopedSlots: { customRender: "selecionar" } },
                { title: "Fornecedor", key: "fornecedor", scopedSlots: { customRender: "fornecedor" } },
                { title: "Cond. pagamento", key: "cond", scopedSlots: { customRender: "cond" } },
                { title: "Entrega prevista", key: "entrega", scopedSlots: { customRender: "entrega" } },
                { title: "Tipo de entrega", key: "tipoEntrega", scopedSlots: { customRender: "tipoEntrega" } },
                { title: "Fat. mín.", key: "faturamentoMinimo", align: "right", scopedSlots: { customRender: "faturamentoMinimo" } },
                { title: "Valor", key: "valor", align: "right", scopedSlots: { customRender: "valor" } },
                { title: "Ações", key: "acoes", scopedSlots: { customRender: "acoes" } },
            ];
        },
        rows() {
            const term = (this.search || "").trim().toLowerCase();

            return this.groupedStores
                .map((store) => {
                    const storeMatches = !term || (store.store_name || "").toLowerCase().includes(term);

                    const pendingProviders = store.pendingProviders.filter((provider) => {
                        if (this.pendencyOnly && !this.isBelowMin(provider)) return false;

                        if (!term) return true;

                        const providerMatches =
                            (provider.provider_name || "").toLowerCase().includes(term) ||
                            (provider.seller_name || "").toLowerCase().includes(term);

                        return storeMatches || providerMatches;
                    });

                    return { ...store, pendingProviders };
                })
                .filter((store) => store.pendingProviders.length);
        },
        selectedOffers() {
            const keys = new Set(this.selectedOfferKeys);
            const offers = [];

            this.groupedStores.forEach((store) => {
                store.pendingProviders.forEach((provider) => {
                    this.leafProducts(provider.products).forEach((product) => {
                        if (keys.has(product.key)) offers.push(product);
                    });
                });
            });

            return offers;
        },
        selectedTotal() {
            return this.selectedOffers.reduce((sum, offer) => sum + (offer.total || 0), 0);
        },
    },
    methods: {
        isPriceLocked(productId, sellerId) {
            return !!this.orderedOffers[`${productId}-${sellerId}`];
        },
        onExpandChange(isExpanded, record) {
            const idx = this.expanded.indexOf(record.store_id);
            if (isExpanded && idx === -1) this.expanded.push(record.store_id);
            else if (!isExpanded && idx !== -1) this.expanded.splice(idx, 1);
        },
        fornecedorTotal(provider) {
            return provider.products.reduce((sum, product) => sum + (product.total || 0), 0);
        },
        storeTotal(store) {
            return store.pendingProviders.reduce((sum, provider) => sum + this.fornecedorTotal(provider), 0);
        },
        // Mirrors PreOrder::isBelowMinimum() server-side (see [[pre-orders-data-source-migration]]):
        // no minimum, or minimum is zero/missing, never counts as below.
        isBelowMin(provider) {
            return !!provider.minimum_billing && this.fornecedorTotal(provider) < provider.minimum_billing;
        },
        deliveryDate(provider) {
            if (!provider.expected_date) return "-";
            return this.$options.filters.formatDateOnly(provider.expected_date);
        },
        setSelection(keys) {
            this.$emit('update:selectedOfferKeys', keys);
        },
        // Controlled checkbox (like loja/fornecedor above), not a-table's
        // native row-selection: that one only reflects clicks made directly
        // on this table — it doesn't re-sync when the "Lojas" sub-table
        // (nested one level deeper, for CROSS groups) drives the selection
        // instead.
        isProductFullySelected(product) {
            const keys = this.selectableKeys([product]);
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isProductPartiallySelected(product) {
            const keys = this.selectableKeys([product]);
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleProductSelection(product, checked) {
            if (checked) {
                const keys = this.selectableKeys([product]);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = this.leafProducts([product]).map((p) => p.key);
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        crossStoreRowSelection(product) {
            const keys = this.selectableKeys(product.stores);

            return {
                selectedRowKeys: keys.filter((key) => this.selectedOfferKeys.includes(key)),
                onChange: (selectedRowKeys) => {
                    const otherKeys = this.selectedOfferKeys.filter((key) => !keys.includes(key));
                    this.setSelection([...otherKeys, ...selectedRowKeys]);
                },
            };
        },
        // "Select all" (whichever level) only ever ADDS products with a
        // quantity typed in — there is nothing to gerar pedido/zerar for an
        // untouched (qty 0) product. Unselecting still clears everything,
        // including any zero-qty product selected individually via its own
        // leaf checkbox. Products are flattened first so a CROSS group
        // (synthetic aggregate, not itself orderable) resolves to its
        // real per-loja leaves.
        selectableKeys(products) {
            return this.leafProducts(products)
                .filter((p) => Number(p.requested_quantity) > 0)
                .map((p) => p.key);
        },
        isProviderFullySelected(provider) {
            const keys = this.selectableKeys(provider.products);
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isProviderPartiallySelected(provider) {
            const keys = this.selectableKeys(provider.products);
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleProviderSelection(provider, checked) {
            if (checked) {
                const keys = this.selectableKeys(provider.products);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = this.leafProducts(provider.products).map((p) => p.key);
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        isLojaFullySelected(record) {
            const keys = this.selectableKeys(record.pendingProviders.flatMap((provider) => provider.products));
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isLojaPartiallySelected(record) {
            const keys = this.selectableKeys(record.pendingProviders.flatMap((provider) => provider.products));
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleLojaSelection(record, checked) {
            const products = record.pendingProviders.flatMap((provider) => provider.products);

            if (checked) {
                const keys = this.selectableKeys(products);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = this.leafProducts(products).map((p) => p.key);
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        isAllFullySelected() {
            const keys = this.selectableKeys(this.rows.flatMap((record) => record.pendingProviders.flatMap((provider) => provider.products)));
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isAllPartiallySelected() {
            const keys = this.selectableKeys(this.rows.flatMap((record) => record.pendingProviders.flatMap((provider) => provider.products)));
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleAllSelection(checked) {
            const products = this.rows.flatMap((record) => record.pendingProviders.flatMap((provider) => provider.products));

            if (checked) {
                const keys = this.selectableKeys(products);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = this.leafProducts(products).map((p) => p.key);
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        bulkGenerateOrder() {
            if (!this.selectedOffers.length) return;

            this.confirm_action({
                message: `Gerar pedido para ${this.selectedOffers.length} oferta(s) selecionada(s)?`,
                confirm_text: "Gerar pedidos",
                callback: () => {
                    this.$emit('generate-orders', this.selectedOfferKeys);
                },
            });
        },
        bulkZeroQuantity() {
            if (!this.selectedOffers.length) return;

            this.confirm_action({
                message: `Zerar a quantidade de ${this.selectedOffers.length} oferta(s) selecionada(s)?`,
                confirm_text: "Zerar quantidade",
                callback: () => {
                    const keys = this.selectedOffers.map((offer) => offer.key);

                    Promise.all(
                        this.selectedOffers.map((offer) => {
                            offer.requested_quantity = 0;

                            return this.svc.sendQuantidade({
                                numerocotacao: this.$route.params.id,
                                quantidade: 0,
                                vendedor: offer.seller_id,
                                produto: offer.id,
                                loja: offer.store_id,
                            });
                        })
                    )
                        .then(() => {
                            keys.forEach((key) => this.$emit('quantity-synced', { key, requested_quantity: 0 }));
                            this.snack("Quantidades zeradas com sucesso.");
                            this.setSelection([]);
                        })
                        .catch((error) => {
                            this.snack("Não foi possível zerar uma ou mais quantidades.", "error");
                            ErrorHandlerService.handle(error, this.$store);
                        });
                },
            });
        },
        bulkExport() {
            if (!this.selectedOffers.length) return;

            const headers = ["Produto", "Fornecedor", "Vendedor", "Loja", "Valor", "Quantidade", "Total"];

            const rows = this.selectedOffers.map((offer) => [
                offer.name,
                offer.provider_name,
                offer.seller_name || "",
                offer.store_name,
                offer.offer_price,
                offer.requested_quantity || 0,
                offer.total || 0,
            ]);

            const csv = [headers, ...rows]
                .map((row) => row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(";"))
                .join("\n");

            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `pre-pedidos-por-loja-${this.$route.params.id}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            this.setSelection([]);
        },
        handleFocus(product) {
            const column = this.stores.find(s => s.id == product.store_id)

            this.$emit('cell-focus', product, column ? column.position : product.store_id, [product])
        },
        saveQuantity(product) {
            this.$emit('save-quantity', {
                key: product.key,
                product_id: product.id,
                store_id: product.store_id,
                seller_id: product.seller_id,
            })
        },
        handleQuantityInput(event, product) {
            let value = event.target.value.replace(/\D/g, '');

            value = value.replace(/^0+(?=\d)/, '');

            if (+value > 999999) {
                value = '999999';
            }

            product.requested_quantity = value;
            this.$emit('quantity-edited', { key: product.key, requested_quantity: value });
            event.target.value = value;
        },
        handleQtyKeydown(event) {
            if (
                !['Enter', 'ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)
            ) {
                return
            }

            event.preventDefault()

            const inputs = Array.from(
                document.querySelectorAll('input.ant-input')
            ).filter(
                el => el.dataset.field === 'loja-qty'
            )

            const currentIndex = inputs.indexOf(event.target)

            if (currentIndex === -1) {
                return
            }

            const forward = ['Enter', 'ArrowDown', 'ArrowRight'].includes(event.key)

            const nextIndex = Math.max(
                0,
                Math.min(currentIndex + (forward ? 1 : -1), inputs.length - 1)
            )

            const nextInput = inputs[nextIndex]

            if (nextInput) {
                nextInput.focus()
                nextInput.select()
            }
        },
        replenishment(product) {
            return replenishmentLabel(product.replenishment_strategy);
        },
        crossGroupOrdered(product) {
            const sum = product.stores.reduce((total, item) => total + (Number(item.requested_quantity) || 0), 0);
            return sum || "—";
        },
        crossExpandIcon({ expanded, record, onExpand }) {
            const h = this.$createElement;

            if (!record.isCrossGroup) {
                return h("span", { class: "ant-table-row-expand-icon ant-table-row-spaced" });
            }

            return h("span", {
                class: ["ant-table-row-expand-icon", expanded ? "ant-table-row-expanded" : "ant-table-row-collapsed"],
                on: { click: (e) => onExpand(record, e) },
            });
        },
        deltaClass(product) {
            if (product.offer_price > product.last_purchase) return "vpm-up";
            if (product.offer_price < product.last_purchase) return "vpm-down";
            return "";
        },
        variation(product) {
            if (!product.last_purchase) return 0;
            return ((product.offer_price - product.last_purchase) / product.last_purchase) * 100;
        },
        lojaActions(record) {
            return [
                { label: "Enviar todos os pedidos", icon: "local_shipping", iconClass: "action-primary", disabled: this.sending[record.store_id] || this.generating, onClick: () => this.sendAllStore(record) },
            ];
        },
        providerActions(record, provider) {
            return [
                { label: "Enviar pedido", icon: "local_shipping", iconClass: "action-primary", disabled: this.sending[record.store_id + "-" + provider.seller_id] || this.generating, onClick: () => this.sendOne(record, provider) },
                { label: "Ver pré-pedido do vendedor", icon: "shopping_cart", iconClass: "action-info", onClick: () => this.openSellerPreOrder(provider) },
                { label: "Ver produtos digitados", icon: "inventory_2", iconClass: "action-teal", onClick: () => this.openTypedProducts(provider) },
                { label: "Adicionar produto", icon: "add_box", iconClass: "action-success", onClick: () => this.openAddProduct(provider) },
            ];
        },
        openSellerPreOrder(provider) {
            const built = buildSellerProviderMatrix(
                this.products,
                provider.seller_id,
                provider.provider_id,
                this.stores
            );

            if (!built) return;

            this.sellerPreOrderModal = { open: true, provider: built };
        },
        closeSellerPreOrder() {
            this.sellerPreOrderModal.open = false;
        },
        openTypedProducts(provider) {
            this.typedProductsModal = {
                open: true,
                providerId: provider.provider_id,
                providerName: provider.provider_name,
                sellerId: provider.seller_id,
                sellerName: provider.seller_name,
            };
        },
        closeTypedProducts() {
            this.typedProductsModal.open = false;
        },
        openAddProduct(provider) {
            this.addProductModal = { open: true, provider };
        },
        closeAddProduct() {
            this.addProductModal.open = false;
        },
        parsePackagingMultiplier(packing) {
            const value = parseInt(String(packing || "").split(" ")[1], 10);
            return Number.isFinite(value) && value > 0 ? value : 1;
        },
        openDistributionForNewProduct(product) {
            const provider = this.addProductModal.provider;
            const packagingMultiplier = this.parsePackagingMultiplier(product.pro_embalagem);

            this.addProductModal.open = false;

            this.$nextTick(() => {
                this.distributionModal = {
                    open: true,
                    winner: {
                        pro_id: product.pro_id,
                        idVendedor: provider.seller_id,
                        valor: 0,
                        nomeFornecedor: provider.provider_name,
                        nomeVendedor: provider.seller_name,
                        embalagem: packagingMultiplier,
                    },
                    product: {
                        descricaoProduto: product.pro_descricao,
                        flag_generico: product.pro_generico,
                        qtd_embalagem: packagingMultiplier,
                        embalagem: product.pro_embalagem,
                        ean: product.pro_ean,
                        internal_code: product.pro_codInterno,
                    },
                    markWinnerOnSave: true,
                };
            });
        },
        closeDistribution() {
            this.distributionModal.open = false;
        },
        onDistributionSaved() {
            this.distributionModal.open = false;
            this.$emit('reload');
        },
        productActions(product, provider) {
            const priceLocked = this.isPriceLocked(product.id, product.seller_id);

            return [
                { label: "Análise de giro", icon: "query_stats", iconClass: "action-info", onClick: () => this.$emit("giro", product, provider.products) },
                { label: "Negociar preço", icon: "handshake", iconClass: "action-success", disabled: priceLocked, tooltip: priceLocked ? PRICE_LOCKED_TOOLTIP : null, onClick: () => this.openNegotiation(product) },
                { label: "Alterar embalagem", icon: "inventory_2", iconClass: "action-warning", onClick: () => this.openWrap(product) },
                { label: "Alterar vencedor", icon: "emoji_events", iconClass: "action-teal", onClick: () => this.openChangeWinner(product) },
                { label: "Histórico de pedidos", icon: "assignment", iconClass: "action-teal", onClick: () => this.openHistory(product) },
                { label: "Alterar tipo de reabastecimento", icon: "sync_alt", iconClass: "action-primary", disabled: this.savingReplenishment === product.id, onClick: () => this.promptReplenishmentStrategy(product) },
            ];
        },
        openChangeWinner(product) {
            this.changeWinnerModal = {
                open: true,
                product,
            };
        },
        closeChangeWinner() {
            this.changeWinnerModal.open = false;
        },
        onWinnerChanged() {
            this.$emit('reload');
        },
        openNegotiation(product) {
            this.negotiationModal = {
                open: true,
                winner: {
                    idVendedor: product.seller_id,
                    idFornecedor: product.provider_id,
                    pro_id: product.id,
                    valor: product.offer_price,
                    nomeVendedor: product.seller_name,
                },
                product: {
                    produtoDescricao: product.name,
                    pro_observacao: product.brand,
                    observacao: product.observations,
                    ultimaCompra: product.last_purchase,
                },
            };
        },
        closeNegotiation() {
            this.negotiationModal.open = false;
            this.$emit('reload');
        },
        openWrap(product) {
            this.wrapModal = {
                open: true,
                winner: {
                    idVendedor: product.seller_id,
                    idFornecedor: product.provider_id,
                    pro_id: product.id,
                    embalagem: product.packing,
                },
                product: {
                    descricaoProduto: product.name,
                    embalagem: product.packing,
                    idProduto: product.id,
                    flag_generico: product.is_generic,
                    pro_principal: product.main_product_id,
                },
            };
        },
        closeWrap() {
            this.wrapModal.open = false;
            this.$emit('reload');
        },
        openHistory(product) {
            this.historyModal = {
                open: true,
                productId: Number(product.id),
                productName: product.name,
            };
        },
        sendOne(row, provider) {
            const key = row.store_id + "-" + provider.seller_id;
            const keys = this.selectableKeys(provider.products);

            this.confirm_action({
                message: `Enviar pedido para ${provider.provider_name}?`,
                confirm_text: "Enviar pedido",
                callback: () => {
                    this.$set(this.sending, key, true);
                    this.$emit('generate-orders', keys);
                },
            });
        },
        sendAllStore(record) {
            const keys = this.selectableKeys(record.pendingProviders.flatMap((provider) => provider.products));

            if (!keys.length) {
                this.snack("Nenhuma quantidade informada para gerar pedido.", "error");
                return;
            }

            this.confirm_action({
                message: `Enviar pedido para todos os ${record.pendingProviders.length} fornecedor(es) de ${record.store_name}?`,
                confirm_text: "Enviar todos",
                callback: () => {
                    this.$set(this.sending, record.store_id, true);
                    this.$emit('generate-orders', keys);
                },
            });
        },
        findOrCreateStore(storeId, storeName) {
            let store = this.groupedStores.find(s => s.store_id == storeId)

            if (!store) {
                store = {
                    key: storeId,
                    store_id: storeId,
                    store_name: storeName,
                    pendingProviders: [],
                }
                this.groupedStores.push(store)
            }

            return store
        },
        findOrCreateProvider(store, pp) {
            let provider = store.pendingProviders.find(f => f.provider_id == pp.provider_id && f.seller_id == pp.seller_id)

            if (!provider) {
                provider = {
                    key: `${store.store_id}-${pp.provider_id}-${pp.seller_id}`,
                    provider_id: pp.provider_id,
                    provider_name: pp.provider_name,
                    provider_cnpj: pp.provider_cnpj,
                    seller_id: pp.seller_id,
                    seller_name: pp.seller_name,
                    seller_phone: pp.seller_phone,
                    payment_condition: pp.payment_condition,
                    expected_date: pp.expected_date,
                    delivery_type: pp.delivery_type,
                    minimum_billing: pp.minimum_billing,
                    products: [],
                }
                store.pendingProviders.push(provider)
            }

            return provider
        },
        pushCrossProduct(provider, pp, leaf) {
            let group = provider.products.find(p => p.isCrossGroup && p.id == pp.id)

            if (!group) {
                group = {
                    ...pp,
                    key: `cross-${pp.id}-${provider.key}`,
                    isCrossGroup: true,
                    request_quantity: 0,
                    total: 0,
                    inventory: null,
                    stores: [],
                }
                provider.products.push(group)
            }

            group.request_quantity += Number(pp.request_quantity) || 0
            group.total += Number(leaf.total) || 0
            group.stores.push(leaf)
        },
        process_available_stores() {
            this.groupedStores = [];

            const cd = this.cdStore;

            this.products.forEach(pp => {
                const leaf = {
                    ...pp,
                    key: `${pp.id}-${pp.store_id}-${pp.provider_id}-${pp.seller_id}`,
                }

                const isCross = pp.replenishment_strategy === CROSS_STRATEGY && !!cd

                const store = isCross
                    ? this.findOrCreateStore(cd.id, cd.name)
                    : this.findOrCreateStore(pp.store_id, pp.store_name)

                const provider = this.findOrCreateProvider(store, pp)

                if (isCross) this.pushCrossProduct(provider, pp, leaf)
                else provider.products.push(leaf)
            })
        },
        leafProducts(products) {
            return products.flatMap(p => (p.isCrossGroup ? p.stores : [p]))
        },
        sort_stores() {
            this.stores.sort((a, b) => {
                if (a.position > b.position) return 1
                if (b.position > a.position) return -1
                return 0
            })
        },
        async loadStores() {
            this.stores = await this.$store.dispatch('user/fetch_stores')
            this.sort_stores()
        },
    },
    created() {
        this.loadStores();
    },
    watch: {
        products: {
            immediate: true,
            handler(value) {
                if (!value || !value.length) return;
                this.process_available_stores();
            }
        },
        stores() {
            if (!this.products || !this.products.length) return;
            this.process_available_stores();
        },
        products_loading(loading) {
            if (!loading) this.sending = {};
        },
    },
};
</script>

<style lang="scss" scoped>
.bl-card {
    --pri: var(--primary-color);
    width: 100%;

    ::v-deep(.ant-card-body) {
        width: 100%;
        padding: 0;
    }
    ::v-deep(.ant-table-wrapper),
    ::v-deep(.ant-table),
    ::v-deep(.ant-table-content),
    ::v-deep(table) {
        width: 100%;
    }
}
.bl-filterbar {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
}
.bl-search-input {
    flex: 1 1 160px;
    min-width: 140px;
    max-width: 260px;
}
.bl-strong {
    font-weight: 600;
    color: #262626;
}
.bl-sup {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.bl-n {
    font-weight: 600;
    color: #262626;
}
.bl-v {
    font-size: 12px;
    color: #8c8c8c;
    font-style: italic;
}
.bl-below-min {
    color: #cf1322;
    font-weight: 600;
}
.bl-btn {
    height: 30px;
    padding: 0 14px;
    border: 1px solid var(--pri);
    background: var(--primary-color-opacity, rgba(232, 96, 44, 0.08));
    color: var(--pri);
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}
::v-deep(.ant-table-expanded-row > td) {
    padding: 0 !important;
    max-width: 0;
}
::v-deep(.ant-table-expanded-row) {
    overflow: hidden;
}
.expanded-table-wrapper {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
}
.vpm-pname {
    font-weight: 600;
    font-size: 13px;
    color: #262626;
}
.vpm-pean {
    font-size: 11px;
    color: #8c8c8c;
}
.vpm-up {
    color: #cf1322;
    font-weight: 600;
}
.vpm-down {
    color: #389e0d;
    font-weight: 600;
}
.matrix-qty-input {
    width: 70px;
    text-align: center;

    .ant-input {
        padding: 2px 4px;
    }
}
.matrix-qty-wrap {
    display: contents;
}
.matrix-qty-wrap.saved ::v-deep(.ant-input) {
    background-color: #13c7213d;
    color: green !important;
}
.repl-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 10px;
    background: #f0f0f0;
    color: #595959;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}
.matrix-cross-total {
    display: inline-block;
    font-weight: 600;
    color: #262626;
}
.ant-table-row-expand-icon.ant-table-row-spaced {
    cursor: default;
}
</style>
